import { strictObjectAccess } from '@ackee/redux-utils';

export const expensesGroups = strictObjectAccess({
    EXPENSES: 'EXPENSES',
    DASHBOARD: 'DASHBOARD',
    SEARCH: 'SEARCH',
    REPORTS: 'REPORTS',
});
